import React from 'react';

import remoteOralExamActions from '../../../../actions/RemoteOralExamActions';
import RemoteOralExamConstants from '../../../../constants/RemoteOralExamConstants';
import { t } from '../../../../services/i18nService';
import storeManager from '../../../../store/StoreManager';
import styles from '../../testOverview.scss';

const ZoomTestCallRetryer = () => {
    const handleTryAgain = () => {
        const store = storeManager.getStore();
        store.dispatch(
            remoteOralExamActions.setTestZoomCallStatus(RemoteOralExamConstants.zoomTestCallStatus.NOT_REQUESTED),
        );
    };

    return (<div>
        <button
            className={`${styles.button} btn`}
            onClick={handleTryAgain}
        >
            {t('general.tryAgain')}
        </button>
    </div>);
};

export default ZoomTestCallRetryer;
